import React, {useState, useRef, useEffect, Fragment} from 'react';
import VisDiv from '../frontend_components/VisDiv';
import { useStateContext } from '../../context/StateContext';
import { v4 as uuidv4 } from 'uuid';
import { addValueForDropdown, errorAlert, keyId, sortByLabel } from '../../lib/utils';
import { useCreateReplace } from '../../hooks/mutations';
import { useQueryClient } from '@tanstack/react-query';
import {StepByStepProgress} from './StepByStepProgress'
import {FieldDropdown, TextField, Divider, ViewLabelValueField, UserIcon} from '../../components';
import { richEditorDoc } from '../gestioneDatabase/Docs';
import { useQuery } from '@tanstack/react-query';
import { clientsQuery, clientsSitesQuery } from '../../lib/data';
import { _FETCH } from '../../lib/patches'
import { ArrayOfObjects, ReferenceCheckList, ImageUploadAndCrop } from './ManagementModules';
import RichTextEditor from '../RichTextEditor';
import TrueFalseToggle from '../TrueFalseToggle';
import { UserEmailPin } from './ReportAperturaEmail';
import { Notes } from './ManagementModules';
import { useAuthContext } from '../../hooks/useAuthContext';


const UserManagement = ({data={}}) => {


    const {customerProducts} = data
    const {customer, apiUrl, users, newUser, setNewUser} = useStateContext()
    const customerId = customer?._id
    const fetchRoute = `${apiUrl}/calls/fetch-docs`
    const {user} = useAuthContext()

    const queryClient = useQueryClient()

    const {data: clients, isLoading: clientsDataLoading} = useQuery(['clientsUserMAnagement', customer], ()=>_FETCH({route: fetchRoute, user, query: clientsQuery(customerId)}),{
        enabled: !! customerId,
        //staleTime: 1000 * 60 * 60,
        onError:(error)=>{
            //console.log("clients not loaded", error)
            //console.log("assignedClientsIds", `*[_type == "client" && _id in [${assignedClientsIds}]]`)
        },
    }) 
    const clientIds = newUser?.assignedClients?.map?.((client)=>`"${client?._ref}"`)

    const {data: sites, isLoading: sitesDataLoading} = useQuery(['sitesUserManagement', clientIds], ()=>_FETCH({route: fetchRoute, user, query: clientsSitesQuery(clientIds)}),{
        enabled: !! clientIds?.length > 0,
        //staleTime: 1000 * 60 * 60,
        onError:(error)=>{
            //console.log("clients not loaded", error)
            //console.log("assignedClientsIds", `*[_type == "client" && _id in [${assignedClientsIds}]]`)
        },
    })


    const {mutate: updateDocument} = useCreateReplace({
        onMutate: async (newDoc) => {

            await queryClient.cancelQueries({ queryKey: ['customersUsersManagement'] })
            const previousData = queryClient.getQueryData(['customersUsersManagement'])
       
            //const doc = newDoc?.doc
            
            queryClient.setQueryData(['customersUsersManagement'], (old) =>{ 
                const doc = newDoc?.doc
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                return newData
            })
            return {previousData}
        },

        onError: (err, newDoc, context) => {
            console.error('Oh no, the update failed: ', err?.message)
            // Instead of just showing an alert, throw the error so ErrorBoundary can catch it
            throw new Error("ERRORE; RICARICA LA PAGINA")
        }
        })

    const save = (data) => {
        setNewUser(data)
        updateDocument({doc: data})
        console.log("SAVE CUSTOMER DOC :", data)
    }

    const languages= [
        {label: "ITALIANO", value: "it"},
        {label: "INGLESE", value: "en"}
    ]
    const userTypes = [
        { label: 'Unknown', value: 'Unknown' },
        { label: 'Customer', value: 'Customer' },
        { label: 'Cliente', value: 'Cliente' },
        { label: 'Tecnico',  value: 'Tecnico' },
        { label: 'Admin',  value: 'Admin' },
        //{ label: 'SuperAdmin', value: 'Super Admin' },
        //{ label: 'GodMode',   value: 'God Mode' },
        { label: 'Fornitore',   value: 'Fornitore' },
      ]
      const professionalTitles = [
        {label: "ARCHITETTO", value:"Architetto"},
        {label: "INGEGNERE", value:"Ingegnere"},
        {label: "GEOMETRA", value:"Geometra"},
        {label: "SIGNOR", value:"Signor"},
        {label: "SIGNORA", value:"Signora"}
      ]
      const incarichi = [
        {label: "SINDACO", value:"Sindaco"},
        {label: "ASSESSORE", value:"Assessore"},
        {label: "RSPP", value:"RSPP"},
        {label: "RESPONSABILE DI SETTORE", value:"Responsabile Di Settore"},
        
      ]

    // REFERENCE DATA FOR REFERENCE ARRAYS
    // if templates is in reference data it filters all the data by the present registers
    const disabledClientsIds = () => {
        const selectedSites = newUser?.assignedSites?.map?.((item)=>!Array.isArray(sites) ? undefined : sites?.find?.((x)=>x?._id == item?._ref))
        const sitesClientsIds = selectedSites?.map?.((site)=>site?.client?._ref)
        return sitesClientsIds
    } 
    const clientsReferenceData = {type: "referenceArray", hideFilter:true, data: clients, propertyName: "assignedClients", disabledIds: disabledClientsIds() }
    const sitesReferenceData = {type: "referenceArray", hideFilter:true, data: sites, propertyName: "assignedSites", }

    const progressList = [
        {description: "ANAGRAFICA", component: <UserDetails doc={newUser} setDoc={save} data={{userTypes, professionalTitles, incarichi}}/>},
        {description: "ASSEGNA CLIENTI", component: <AssignClients doc={newUser} setDoc={save} data={{referenceData: clientsReferenceData}}/>},
        {description: "ASSEGNA PLESSI", component: <AssignSites doc={newUser} setDoc={save} data={{referenceData: sitesReferenceData}}/>},
        {description: "CONTATTI", component: <UserContacts doc={newUser} setDoc={save} data={{}}/>},
        {description: "FOTO PROFILO", component: <ProfilePicture doc={newUser} setDoc={save} data={{}}/>},
        {description: "NOTE", component: <Notes doc={newUser} setDoc={save} data={{}}/>},
      ] 

      const testFunction = () => {
        console.log("TEST DOC CUSTOMER PRODUCT", newUser)
      }
      const resetDoc = () => {
        setNewUser(undefined)
      }
  return (
    <div>   
        <VisDiv rules={[false]}>
            <button onClick={testFunction}>TEST DOC</button>
        </VisDiv>
        <VisDiv rules={[newUser]}>
            <button onClick={resetDoc} className={"pdf-button"}>CHIUDI DOCUMENTO</button>
        </VisDiv>
        <VisDiv rules={[!newUser]}>
           <AddOrEditUser doc={newUser} setDoc={save} data={{...data, clients}}/> 
        </VisDiv>
        <VisDiv rules={[newUser]}>
            <StepByStepProgress progressList={progressList}/>
        </VisDiv>
    </div>
  )
}

export default UserManagement

export const AddOrEditUser = ({doc, setDoc, data={}}) => { 

    const {customer, apiUrl} = useStateContext()
    const [email, setUserEmail] = useState("")
    const [selectedUser, setSelectedUser] = useState("")
    const {users, clients} = data 
    const fetchRoute = `${apiUrl}/calls/fetch-docs`
    const {user} = useAuthContext()
    const clientIds = selectedUser?.assignedClients?.map?.((client)=>`"${client?._ref}"`)

    const {data: sites, isLoading: sitesDataLoading} = useQuery(['sitesUserManagement', clientIds], ()=>_FETCH({route: fetchRoute, user, query: clientsSitesQuery(clientIds)}),{
        enabled: !! clientIds?.length > 0,
        //staleTime: 1000 * 60 * 60,
        onError:(error)=>{
            //console.log("clients not loaded", error)
            //console.log("assignedClientsIds", `*[_type == "client" && _id in [${assignedClientsIds}]]`)
        },
    })
    //console.log("dnwkjdnejn", users)
    const usersArray = (!users || users?.error || users?.length < 1 ) ? [] : users
    const usersOptions = usersArray?.map?.((user)=>({...user, label: user?.email, value: user?.email}))

    const duplicateDoc = () => ({
        ...selectedUser, 
        label: email, 
        _id: uuidv4(), 
        _key: keyId(),
    })

    const emptyDoc = () => ({
        _type: "user",
        _id: uuidv4(),
        _key: keyId(),
        firstName: "",
        lastName: "",
        language: "it",
        image:{},
        email: "",
        userType: "Unknown",
        professionalTitle:"",
        jobTitle:"",
        incarico:"",
        customer: referenceDoc(customer?._id),
        assignedClients: [],
        assignedSites: [],
        emailList: [],
        phoneList: [],
        emailComms:[],
        notes: richEditorDoc(""),
        status:"ATTIVO",
    })
    const labelValueDistance = 5


    const selectedUserData = [
        {label: "NOME", value: selectedUser?.firstName},
        {label: "COGNOME", value: selectedUser?.lastName},
        {label: "EMAIL", value: selectedUser?.email},
        {highlight: "amber", value: selectedUser?.notification && "RICEVE NOTIFICHE GRAVI"},
        {label: "FOTO PROFILO", value: selectedUser?.image, type:"userIcon"},
        {label: "TIPOLOGIA UTENTE", value: selectedUser?.userType},
        {label: "TITOLO PROFESSIONALE", value: selectedUser?.professionalTitle},
        {label: "INCARICO", value: selectedUser?.incarico},
        {label: "POSIZIONE", value: selectedUser?.jobTitle},
        {label: "CLIENTI ASSEGNATI", value: selectedUser?.assignedClients?.map?.((item)=> !Array.isArray(clients) ? undefined : clients?.find?.((x)=>x?._id == item?._ref)?.label)?.toString()},
        {label: "PLESSI ASSEGNATI", value: selectedUser?.assignedSites?.map?.((item)=>!Array.isArray(sites) ? undefined : sites?.find?.((x)=>x?._id == item?._ref)?.label)?.toString()},
        {label: "NOTE", value: selectedUser?.notes?.blocks?.map?.((x)=>x?.text)?.toString()},
    ]
    
    const createNewEmptyDoc = () => {
        if(email){
            setDoc({...emptyDoc(), label: email, value: email})
        } else {
            Swal.fire({
                position: 'top',
                icon: 'warning',
                title: "INSERIRE L'EMAIL DELL'UTENTE",
                showConfirmButton: false,
                timer: 1500
              })
        }
    }
    const duplicateExistingDoc = () => {
        const checks = () => {
            return true
        }
        if(!checks()){
            errorAlert("Il prodotto non è stato duplicato, ricaricare e riprovare")
        }
        else if(email){
            setDoc(duplicateDoc())
            console.log("DUPLICATE DOC widhwdh", duplicateDoc())
        } else {
            Swal.fire({
                position: 'top',
                icon: 'warning',
                title: "INSERIRE IL NOME DEL PRODOTTO",
                showConfirmButton: false,
                timer: 1500
              })
        }
    }
    const editExistingDoc = () => {
        setDoc(selectedUser)
    }
    return (
    <div>
        <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            //initialValue={expandSupplier(supplierProduct?.supplier)}
            placeHolder={"SELEZIONA UTENTE ESISTENTE"}
            options={usersOptions}
            onChange={(value) => { 
                setSelectedUser(value)
            }}
        />
        <TextField 
            value={email} 
            label={"EMAIL NUOVO UTENTE"}
            onChange={(e) => setUserEmail(e.target.value)} 
            description={"Inserire un email per creare un nuovo utente o per duplicare uno esistente."} 
            descriptionDivider={false}
        />
        <div style={{display:"flex", justifyContent:"space-evenly"}}>
            <VisDiv rules={[email, !selectedUser]}>
                <button className="pdf-button" onClick={createNewEmptyDoc} >INSERISCI VUOTO</button>
            </VisDiv>
            <VisDiv rules={[selectedUser, !email]}> 
                <button className="pdf-button" onClick={editExistingDoc} >MODIFICA UTENTE ESISTENTE</button>
            </VisDiv>
            <VisDiv rules={[selectedUser, email]}>
                <button className="pdf-button" onClick={duplicateExistingDoc} >DUPLICA UTENTE</button>
            </VisDiv>
        </div>
        <VisDiv rules={[selectedUser]}>
            <Divider/>
            {selectedUserData?.map?.((item,index)=>{
                if(item?.type == "userIcon" && item?.value) return(

                <ViewLabelValueField 
                label={item?.label} 
                labelValueDistance={labelValueDistance}>
                    <UserIcon otherUser={selectedUser} size={250}/>
                </ViewLabelValueField>
                  
                )
                return(
                    <VisDiv key={index} rules={[item?.value]}>
                        <ViewLabelValueField 
                            label={item?.label} 
                            value={item?.value}
                            labelValueDistance={labelValueDistance}
                            highlight={item?.highlight}
                        />
                    </VisDiv>
                )
            })}
            <UserEmailPin title={"COMUNICAZIONI"} index={1} user={selectedUser}/>

        </VisDiv>
    </div>
)}

export const UserDetails = ({doc, setDoc, data={}}) => {
    const {professionalTitles, userTypes, incarichi} = data
    const [detailsDoc, setDetailsDoc] = useState(doc)
    return  (  
     <div>
        <TextField 
            label={"NOME"}
            value={detailsDoc?.firstName} 
            onBlur={()=>setDoc(detailsDoc)}
            onChange={(e) => setDetailsDoc({...doc, firstName: e.target.value})} 
            //description={"Questo dato non sarà inserito nell'offerta, serve per trovare il prodotto"} 
            descriptionDivider={false}
        />
        <TextField 
            label={"COGNOME"}
            value={detailsDoc?.lastName} 
            onBlur={()=>setDoc(detailsDoc)}
            onChange={(e) => setDetailsDoc({...doc, lastName: e.target.value})} 
            //description={"Questo dato non sarà inserito nell'offerta, serve per trovare il prodotto"} 
            descriptionDivider={false}
        />
         <h4>TITOLO PROFESSIONALE:</h4>
        <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            initialValue={{label:doc?.professionalTitle, value: doc?.professionalTitle,}}
            placeHolder={"SELEZIONA TITOLO PROFESSIONALE"}
            options={professionalTitles}
            onChange={(value) => { 
                setDoc({...doc, professionalTitle: value?.value})
            }}
        />
        <h4>INCARICO:</h4>
        <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            initialValue={{label:doc?.incarico, value: doc?.incarico,}}
            placeHolder={"SELEZIONA INCARICO"}
            options={incarichi}
            onChange={(value) => { 
                setDoc({...doc, incarico: value?.value})
            }}
        />
       <TextField 
            label={"MANSIONE"}
            value={detailsDoc?.jobTitle} 
            onBlur={()=>setDoc(detailsDoc)}
            onChange={(e) => setDetailsDoc({...doc, jobTitle: e.target.value})} 
            description={"Questo dato non descrive la posizione specifica dell'utente"} 
            descriptionDivider={true}
        />
        <h4 style={{marginTop:"10px"}}>TIPOLOGIA UTENTE:</h4>
        <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            initialValue={{label:doc?.userType, value: doc?.userType}}
            placeHolder={"SELEZIONA TIPOLOGIA UTENTE"}
            options={userTypes}
            onChange={(value) => { 
                setDoc({...doc, userType: value?.value})
            }}
        />
    </div>
    ) 
}
export const UserContacts = ({doc, setDoc, data={}}) => {
    const [email, setEmail]= useState(doc?.email)
    const emailData = {
        //existingArray: doc?.emailList ? doc?.emailList : [], 
        arrayName:"emailList",
        buttonTitle:"AGGIUNGI EMAIL",
        objectSchema: [
            {key: "email", title:"E-Mail", type:"string", order: 1},
            {key: "description", title:"Descrizione", type: "string", order: 2},
            {key: "notification", title:"Notifica", type: "boolean", order: 3, highlight: "amber", boolValue: "RICEVE NOTIFICHE GRAVI", fieldDescription: "Selezionare questa opzione se si vuole notificare le non conformità gravi."},
        ],
        emptyObject: {    
            email: "",
            description: "",
            notification: false
        }
    }
    const phoneData = {
        arrayName:"phoneList",
        buttonTitle:"AGGIUNGI NUMERO DI TELEFONO",
        objectSchema: [
            {key: "phoneNumber", title:"E-Mail", type:"string", order: 1},
            {key: "description", title:"Descrizione", type: "string", order: 2},
        ],
        emptyObject: {    
            phoneNumber: "",
            description: "",
        }
    }

    return (
   <div>
        <TextField
            label={"EMAIL"}
            value={email} 
            onBlur={()=>setDoc({...doc, email})}
            onChange={(e) => setEmail(e.target.value)} 
            description={"Quest'indirizzo email verrà utilizzato dal cliente per fare il log in"} 
            descriptionDivider={true}
        />
        <TrueFalseToggle 
            value={doc?.notification}
            onClick={()=>setDoc({...doc, notification: !doc?.notification})}
            label={"NOTIFICHE GRAVI"} 
            description={"Selezionare questa opzione se si vuole notificare le non conformità gravi. "}
        />
        <h4 style={{marginTop:"10px"}}>EMAIL AGGIUNTIVE:</h4>
        <ArrayOfObjects
            data={emailData}
            doc={doc}
            setDoc={setDoc}
        />
                <h4 style={{marginTop:"10px"}}>TELEFONI AGGIUNTIVI:</h4>
        <ArrayOfObjects
            data={phoneData}
            doc={doc}
            setDoc={setDoc}
        />
   </div>
)
}
export const AssignClients = ({doc, setDoc, data={referenceData}}) => {
    const {referenceData} = data
    return (
    <ReferenceCheckList doc={doc} setDoc={setDoc} referenceData={referenceData}/>
)
}
export const AssignSites = ({doc, setDoc, data={}}) => {
    const {referenceData} = data
    return (
    <ReferenceCheckList doc={doc} setDoc={setDoc} referenceData={referenceData}/>
)}
export const ProfilePicture = ({doc, setDoc, data={}}) => {

    return  (
    <div>
        <ImageUploadAndCrop doc={doc} setDoc={setDoc}/>     
    </div>
    ) 
}
/* export const Notes = ({doc, setDoc, data={}}) => {
    const [value, setValue] = useState(doc)
    const saveNote = () => {
        //const newValue = {...value, details: {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}}
        //console.log("EDITOR BLUR", value)
        setDoc(value)
     }
     const editorDocNote = (data) => {
        //console.log("EDITOR DOC", data)
        const newValue = {...value, notes: {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}}
        setValue(newValue)

    }
    return ( 
        <div>
             <RichTextEditor onBlur={saveNote} noFocus={true} existingDoc={doc?.notes} readOnly={false} editorDoc={editorDocNote}/>
        </div>

)
} */